import { Context } from '@nuxt/types/app';

// Block /_preview routes in production
export default function blockPreview({ route, error }: Context) {
  if (
    (process.env.NUXT_ENV_IS_PROD === 'true' || process.env.NUXT_ENV_IS_STAGING === 'true')
    && route.path.startsWith('/_preview')
  ) {
    error({ statusCode: 404, message: 'Page not found' });
  }
}
